module.exports = __webpack_public_path__ + "static/img/White_Background_Logo copy1920x600.697cbfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/White_Background_Logo copy1920x600.png
// module id = 1129
// module chunks = 1